export const ApplicationId = "#{qccat.app.applicationId}";
export const LoginUrl = "#{qccat.auth.loginUrl}";
export const WebServiceUrl = "#{qccat.app.urlBase}/#{qccat.app.applicationName}/";
export const NotifyRequestRejectedUrl = "api/RequestIssue/NotifyRequestRejectedResponse";
export const BreastTechnicalAppendixUrl = "#{qccat.dash.www.breastTAUrl}";
export const BreastIndicatorDefinitionsUrl = "#{qccat.dash.www.breastIndicatorDefinitionsUrl}";
export const CrcTechnicalAppendixUrl = "#{qccat.dash.www.crcTAUrl}";
export const ColonIndicatorDefinitionsUrl = "#{qccat.dash.www.colonIndicatorDefinitionsUrl}";
export const RectalIndicatorDefinitionsUrl = "#{qccat.dash.www.rectalIndicatorDefinitionsUrl}";
//export const LungTechnicalAppendixUrl = "#{qccat.dash.www.lungTAUrl}";
export const LungIndicatorDefintionsUrl = "#{qccat.dash.www.lungIndicatorDefinitionsUrl}";
export const LungIndicatorYear = "2022";
export const LUCiDUrl = "#{qccat.dash.www.lucidUrl}";
export const AMLIndicatorDefinitionsUrl = "#{qccat.dash.www.amlIndicatorDefinitionsUrl}";
export const AMLTechnicalAppendixUrl = "#{qccat.dash.www.amlTAUrl}";
export const BrainTechnicalAppendixUrl = "#{qccat.dash.www.brainTAUrl}";
export const BrainIndicatorDefinitionsUrl = "#{qccat.dash.www.brainIndicatorDefinitionsUrl}";
export const HeadAndNeckTechnicalAppendixUrl = "#{qccat.dash.www.hanTAUrl}";
export const HeadAndNeckIndicatorDefintionsUrl = "#{qccat.dash.www.headAndNeckIndicatorDefinitionsUrl}";
export const HHSLabel = "#{qccat.app.hhsLabel}";
export const StateLabel = "#{qccat.app.stateLabel}";
export const ServerAppBasename = "/#{qccat.app.applicationName}/";
export const DashboardKeys = () => JSON.parse("#{qccat.app.uidashboardkeys}");
export const StateWideBreastIndicators = () => JSON.parse(`#{qccat.app.stateWideBreastIndicators}`);
export const StateWideLungIndicators = () => JSON.parse(`#{qccat.app.stateWideLungIndicators}`);
export const StateWideCRCIndicators = () => JSON.parse(`#{qccat.app.stateWideCRCIndicators}`);
export const StateWideBrainIndicators = () => JSON.parse(`#{qccat.app.stateWideBrainIndicators}`);
export const StateWideHANIndicators = () => JSON.parse(`#{qccat.app.stateWideHeadAndNeckIndicators}`);
export const StateWideAMLIndicators = () => JSON.parse(`#{qccat.app.stateWideAMLIndicators}`);
